export const GET_USER_PRODUCTS_LIST_PENDING = 'GET_USER_PRODUCTS_LIST_PENDING';
export const GET_USER_PRODUCTS_LIST_FULFILLED = 'GET_USER_PRODUCTS_LIST_FULFILLED';
export const GET_USER_PRODUCTS_LIST_REJECTED = 'GET_USER_PRODUCTS_LIST_REJECTED';

export default function userProductsListReducer(state = {
  fetching: false,
  fetched: false,
  products: []
}, { type, payload }) {
  switch (type) {
    case GET_USER_PRODUCTS_LIST_PENDING:
      return {
        ...state,
        fetching: true
      };
    case GET_USER_PRODUCTS_LIST_FULFILLED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        products: payload
      };
    case GET_USER_PRODUCTS_LIST_REJECTED:
      return {
        ...state,
        fetching: false,
        fetched: true
      };
    default:
      return state;
  }
}
